module.exports = __webpack_public_path__ + "assets/img/d5e1a2288e06cd96936796f93a226957.png";